// extracted by mini-css-extract-plugin
export var printerCard = "_bl-1";
export var printerCardConfigured = "_bl-2";
export var printerCardError = "_bl-3";
export var printerCardsContainer = "_bl-0";
export var printerIcon = "_bl-8";
export var printerIconConfigured = "_bl-5";
export var printerIconContainer = "_bl-4";
export var printerIconError = "_bl-6";
export var printerIconUnconfigured = "_bl-7";